import {ColumnDef} from "@tanstack/react-table"
import {CompanyRepresentation} from "@/pages/companies/page.tsx";
import {Avatar, AvatarFallback} from "@/components/ui/avatar.tsx";
import {Button} from "@/components/ui/button.tsx";
import {Printer, RefreshCw} from "lucide-react";
import {AuthContextProps} from "react-oidc-context";
import axios from "axios";
import {toast} from "sonner";


export const DocumentStates : { [key: string]: string } = {
    "DRAFT": "Piszkozat",
    "ORDER_PENDING": "Megrendelésre vár",
    "ORDER_CONFIRMED": "Megrendelve",
    "ORDER_DELIVERED": "Kiküldve",
    "ARCHIVED_SUCCESSFUL": "Sikeres",
    "ARCHIVED_CANCELLED": "Elutasítva",
};

function updateCompany(regNum: string) {
    axios.put("/api/company/" + regNum).then((res) => {
        if (res.status === 200) {
            toast.success("Cégadatok sikeresen frissítve")
        }
    })
}


export function columns(auth: AuthContextProps): ColumnDef<CompanyRepresentation>[] {
    return [
        {
            accessorKey: "name",
            header: "Név",
            cell: ({row}) => {
                const name = row.getValue<string>('name')
                return (
                    <div className={"flex gap-2 items-center"}>
                        <Avatar className="h-8 w-8 rounded bg-black">
                            <AvatarFallback
                                className="rounded-md bg-black text-sidebar-foreground">{row.original.name.split(" ").slice(0, -1).splice(0, 2).map(x => x[0])}</AvatarFallback>
                        </Avatar>

                        <div className={"flex flex-col"}>
                            <span className={"font-bold"}>{name}</span>
                            <span className={"font-bold text-muted-foreground"}>{row.original.tax_number}</span>
                        </div>
                    </div>
                )
            }
        },
        {
            accessorKey: "registration_number",
            header: "Cégjegyzékszám",
        },
        {
            accessorKey: "user",
            header: "Kihez tartozik",
            cell: ({row}) => {
                const user = row.getValue<{
                    name: string,
                    email: string,
                    id: string
                }>('user')
                return (
                    <div className={"flex items-center gap-2"}>
                        <Avatar className="h-8 w-8 rounded bg-black">
                            <AvatarFallback
                                className="rounded-md bg-black text-sidebar-foreground">{user.name.split(" ").map(x => x[0])}</AvatarFallback>
                        </Avatar>
                        <div className={"flex flex-col"}>
                            <p className={"font-bold"}>{user.name}</p>
                            <p className={"text-sm"}>{user.email}</p>
                        </div>
                    </div>
                )
            }
        },
        {
            accessorKey: "updated_at",
            header: "Módosítva",
            cell: ({row}) => {
                const date = new Date(row.getValue('updated_at'))
                return (
                    <div className="lowercase">{date.toLocaleDateString("hu-HU")}</div>
                )
            }
        },
        {
            header: "Műveletek",
            cell: ({row}) => {
                const item = row.original
                return (
                    <div className={"flex gap-2"}>
                        <Button variant={"ghost"} asChild>
                            <a href={"/api/company/" + item.id + "/abstract?api_key=" + auth.user?.access_token}
                               target={"_blank"}>
                                <Printer/>
                            </a>
                        </Button>

                        <Button variant={"ghost"} onClick={() => updateCompany(row.original.registration_number)}>
                            <RefreshCw/>
                        </Button>
                    </div>
                )
            }
        }
    ]
}